import DynamicFieldsSerializer from '@linc-technologies/linced-common/serializers/dynamic-fields';

export default class MedicalCondition extends DynamicFieldsSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      description: '',
      priority: 9,
      prescribedMedicationHeld: false,
      anaphylaxis: false,
      highRisk: false,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
